import { render, staticRenderFns } from "./Xucun.vue?vue&type=template&id=bc26390e&scoped=true"
import script from "./Xucun.vue?vue&type=script&lang=js"
export * from "./Xucun.vue?vue&type=script&lang=js"
import style0 from "./Xucun.vue?vue&type=style&index=0&id=bc26390e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc26390e",
  null
  
)

export default component.exports